const GET_RP_EVENT_PARTICIPANT = 'dofe-bo/advjouEvents/GET_RP_EVENT_PARTICIPANT'
const GET_RP_EVENT_PARTICIPANT_SUCCESS =
  'dofe-bo/advjouEvents/GET_RP_EVENT_PARTICIPANT_SUCCESS'
const GET_RP_EVENT_PARTICIPANT_FAIL =
  'dofe-bo/advjouEvents/GET_RP_EVENT_PARTICIPANT_FAIL'

const GET_RP = 'dofe-bo/advjouEvents/GET_RP'
const GET_RP_SUCCESS = 'dofe-bo/advjouEvents/GET_RP_SUCCESS'
const GET_RP_FAIL = 'dofe-bo/advjouEvents/GET_RP_FAIL'

const UPDATE_RESIDENTIAL_PROJECT =
  'dofe-bo/activities/UPDATE_RESIDENTIAL_PROJECT'
const UPDATE_RESIDENTIAL_PROJECT_SUCCESS =
  'dofe-bo/activities/UPDATE_RESIDENTIAL_PROJECT_SUCCESS'
const UPDATE_RESIDENTIAL_PROJECT_FAIL =
  'dofe-bo/activities/UPDATE_RESIDENTIAL_PROJECT_FAIL'
const APPROVE_RESIDENTIAL_PROJECT =
  'dofe-bo/activities/APPROVE_RESIDENTIAL_PROJECT'
const APPROVE_RESIDENTIAL_PROJECT_SUCCESS =
  'dofe-bo/activities/APPROVE_RESIDENTIAL_PROJECT_SUCCESS'
const APPROVE_RESIDENTIAL_PROJECT_FAIL =
  'dofe-bo/activities/APPROVE_RESIDENTIAL_PROJECT_FAIL'

const SIGNOFF_RESIDENTIAL_PROJECT =
  'dofe-bo/activities/SIGNOFF_RESIDENTIAL_PROJECT'
const SIGNOFF_RESIDENTIAL_PROJECT_SUCCESS =
  'dofe-bo/activities/SIGNOFF_RESIDENTIAL_PROJECT_SUCCESS'
const SIGNOFF_RESIDENTIAL_PROJECT_FAIL =
  'dofe-bo/activities/SIGNOFF_RESIDENTIAL_PROJECT_FAIL'

const SIGNOFF_REQUEST_RESIDENTIAL_PROJECT =
  'dofe-bo/activities/SIGNOFF_REQUEST_RESIDENTIAL_PROJECT'
const SIGNOFF_REQUEST_RESIDENTIAL_PROJECT_SUCCESS =
  'dofe-bo/activities/SIGNOFF_REQUEST_RESIDENTIAL_PROJECT_SUCCESS'
const SIGNOFF_REQUEST_RESIDENTIAL_PROJECT_FAIL =
  'dofe-bo/activities/SIGNOFF_REQUEST_RESIDENTIAL_PROJECT_FAIL'

const CHANGE_RESIDENTIAL_PROJECT_STATE =
  'dofe-bo/activities/CHANGE_RESIDENTIAL_PROJECT_STATE'
const CHANGE_RESIDENTIAL_PROJECT_STATE_SUCCESS =
  'dofe-bo/activities/CHANGE_RESIDENTIAL_PROJECT_STATE_SUCCESS'
const CHANGE_RESIDENTIAL_PROJECT_STATE_FAIL =
  'dofe-bo/activities/CHANGE_RESIDENTIAL_PROJECT_STATE_FAIL'

const RP_CHANGE_ASSESSOR = 'dofe-bo/activities/RP_CHANGE_ASSESSOR'
const RP_CHANGE_ASSESSOR_SUCCESS =
  'dofe-bo/activities/RP_CHANGE_ASSESSOR_SUCCESS'
const RP_CHANGE_ASSESSOR_FAIL = 'dofe-bo/activities/RP_CHANGE_ASSESSOR_FAIL'

const GET_RP_ASSESSMENT = 'dofe-bo/activities/GET_RP_ASSESSMENT'
const GET_RP_ASSESSMENT_SUCCESS = 'dofe-bo/activities/GET_RP_ASSESSMENT_SUCCESS'
const GET_RP_ASSESSMENT_FAIL = 'dofe-bo/activities/GET_RP_ASSESSMENT_FAIL'
const REMOVE_RESIDENTIAL_PROJECT_ASSESSMENT =
  'dofe-bo/activities/REMOVE_RESIDENTIAL_PROJECT_ASSESSMENT'

const ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT =
  'dofe-bo/advjouEvents/ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT'
const ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_SUCCESS =
  'dofe-bo/advjouEvents/ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_SUCCESS'
const ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_FAIL =
  'dofe-bo/advjouEvents/ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_FAIL'

const RR_ASSESSMENT_RESEND = 'dofe-bo/advjouEvents/RR_ASSESSMENT_RESEND'
const RR_ASSESSMENT_RESEND_SUCCESS =
  'dofe-bo/advjouEvents/RR_ASSESSMENT_RESEND_SUCCESS'
const RR_ASSESSMENT_RESEND_FAIL =
  'dofe-bo/advjouEvents/RR_ASSESSMENT_RESEND_FAIL'

const GET_RP_REPORT = 'dofe-bo/activities/GET_ACTIVITY_REPORT'
const GET_RP_REPORT_SUCCESS = `${GET_RP_REPORT}_SUCCESS`
const GET_RP_REPORT_FAIL = `${GET_RP_REPORT}_FAIL`

const initialState = {
  list: [],
  detail: {},
  assessment: {
    data: {},
    loading: false
  },
  loading: false,
  loaded: false,
  sending: false,
  reportSent: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case GET_RP_EVENT_PARTICIPANT:
      return {
        ...state,
        loading: true
      }
    case GET_RP_EVENT_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        eventParticipants: action.result,
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_RP_EVENT_PARTICIPANT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_RP:
      return {
        ...state,
        loading: true
      }
    case GET_RP_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case GET_RP_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_RESIDENTIAL_PROJECT:
      return {
        ...state,
        loading: true
      }
    case UPDATE_RESIDENTIAL_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result
      }
    case UPDATE_RESIDENTIAL_PROJECT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT:
      return {
        ...state,
        sending: true
      }
    case ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_SUCCESS:
      return {
        ...state,
        sending: false,
        reportSent: true,
        error: null
      }
    case ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_FAIL:
      return {
        ...state,
        sending: false,
        reportSent: false,
        error: action.error
      }
    case RR_ASSESSMENT_RESEND:
      return {
        ...state,
        loading: true
      }
    case RR_ASSESSMENT_RESEND_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case RR_ASSESSMENT_RESEND_FAIL:
      return {
        ...state,
        loading: false
      }
    case GET_RP_ASSESSMENT:
      return {
        ...state,
        assessment: {
          loading: true
        }
      }
    case GET_RP_ASSESSMENT_SUCCESS:
      return {
        ...state,
        assessment: {
          loading: false,
          data: action.result
        }
      }
    case GET_RP_ASSESSMENT_FAIL:
      return {
        ...state,
        assessment: {
          loading: false,
          error: action.error
        }
      }
    case REMOVE_RESIDENTIAL_PROJECT_ASSESSMENT:
      return {
        ...state,
        assessment: {
          data: {},
          loading: false
        }
      }
    default:
      return state
  }
}

export function updateResidentialProject (id, data) {
  return {
    types: [
      UPDATE_RESIDENTIAL_PROJECT,
      UPDATE_RESIDENTIAL_PROJECT_SUCCESS,
      UPDATE_RESIDENTIAL_PROJECT_FAIL
    ],
    promise: client =>
      client.post(`api/residential-projects/${id}/edit`, {
        data
      })
  }
}

export function setupResidentialProject (id, data) {
  return {
    types: [
      UPDATE_RESIDENTIAL_PROJECT,
      UPDATE_RESIDENTIAL_PROJECT_SUCCESS,
      UPDATE_RESIDENTIAL_PROJECT_FAIL
    ],
    promise: client =>
      client.post(`api/residential-projects/${id}/setup`, {
        data
      })
  }
}

export function getPublicRpEvent (id, authCode) {
  return {
    types: [
      GET_RP_EVENT_PARTICIPANT,
      GET_RP_EVENT_PARTICIPANT_SUCCESS,
      GET_RP_EVENT_PARTICIPANT_FAIL
    ],
    promise: client =>
      client.get(
        `api/residential-projects/${id}/using-authorization-code?authorizationCode=${authCode}&with=AWARD,PARTICIPANT_DETAILS`,
        {
          removeToken: true,
          unauthorizedAction: false
        }
      )
  }
}

export function getRpEvent (id) {
  return {
    types: [GET_RP, GET_RP_SUCCESS, GET_RP_FAIL],
    promise: client =>
      client.get(
        `api/residential-projects/${id}?with=APPEND_CUSTOMIZATIONS,ACTIVITY_CATEGORY,ASSESSOR_REGISTRATION,ASSESSOR_REGISTRATION_DATA,ASSESSOR`
      )
  }
}

export function getResidentialProjectAssessment (rpId, actionId) {
  return {
    types: [
      GET_RP_ASSESSMENT,
      GET_RP_ASSESSMENT_SUCCESS,
      GET_RP_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(`api/residential-projects/${rpId}/assessments/${actionId}`)
  }
}

export function getPublicResidentialProjectAssessmentRequests (
  activityId,
  activityActionId,
  authCode
) {
  return {
    types: [
      GET_RP_ASSESSMENT,
      GET_RP_ASSESSMENT_SUCCESS,
      GET_RP_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(
        `api/residential-projects/${activityId}/assessment-requests/${activityActionId}/using-authorization-code?authorizationCode=${authCode}`,
        {
          removeToken: true,
          unauthorizedAction: false
        }
      )
  }
}

export function sendResidentialProjectAssessorReport (id, authCode, data) {
  return {
    types: [
      ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT,
      ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_SUCCESS,
      ASSESSOR_APPROVE_RP_PARTICIPANT_EVENT_FAIL
    ],
    promise: client =>
      client.post(
        `api/residential-projects/${id}/assessor-reports/using-authorization-code?authorizationCode=${authCode}`,
        {
          data,
          removeToken: true,
          removeUserType: true
        }
      )
  }
}

export function approveResidentialProject (id, data) {
  return {
    types: [
      APPROVE_RESIDENTIAL_PROJECT,
      APPROVE_RESIDENTIAL_PROJECT_SUCCESS,
      APPROVE_RESIDENTIAL_PROJECT_FAIL
    ],
    promise: client =>
      client.post(`api/residential-projects/${id}/approval`, {
        data
      })
  }
}

export function signoffResidentialProject (id, data) {
  return {
    types: [
      SIGNOFF_RESIDENTIAL_PROJECT,
      SIGNOFF_RESIDENTIAL_PROJECT_SUCCESS,
      SIGNOFF_RESIDENTIAL_PROJECT_FAIL
    ],
    promise: client =>
      client.post(`api/residential-projects/${id}/award-leader-signoff`, {
        data
      })
  }
}

export function signoffRequestResidentialProject (id, requestId) {
  return {
    types: [
      SIGNOFF_REQUEST_RESIDENTIAL_PROJECT,
      SIGNOFF_REQUEST_RESIDENTIAL_PROJECT_SUCCESS,
      SIGNOFF_REQUEST_RESIDENTIAL_PROJECT_FAIL
    ],
    promise: client =>
      client.get(
        `api/residential-projects/${id}/sign-off-requests/${requestId}`
      )
  }
}

export function changeRpState (id, state, data = {}) {
  return {
    types: [
      CHANGE_RESIDENTIAL_PROJECT_STATE,
      CHANGE_RESIDENTIAL_PROJECT_STATE_SUCCESS,
      CHANGE_RESIDENTIAL_PROJECT_STATE_FAIL
    ],
    promise: client =>
      client.post(
        `api/residential-projects/${id}/state-change?state=${state}`,
        {
          data
        }
      )
  }
}

export function changeRpAssessor (id, data) {
  return {
    types: [
      RP_CHANGE_ASSESSOR,
      RP_CHANGE_ASSESSOR_SUCCESS,
      RP_CHANGE_ASSESSOR_FAIL
    ],
    promise: client =>
      client.post(`api/residential-projects/${id}/change-assessor`, {
        data
      })
  }
}

export function resendRpAssessmentRequest (id) {
  return {
    types: [
      RR_ASSESSMENT_RESEND,
      RR_ASSESSMENT_RESEND_SUCCESS,
      RR_ASSESSMENT_RESEND_FAIL
    ],
    promise: client =>
      client.post(`api/residential-projects/${id}/resend-assessment-requests`)
  }
}

export function removeResidentialProjectAssessment () {
  return {
    type: REMOVE_RESIDENTIAL_PROJECT_ASSESSMENT
  }
}

export function getRPReport (rpId) {
  return {
    types: [GET_RP_REPORT, GET_RP_REPORT_SUCCESS, GET_RP_REPORT_FAIL],
    promise: client => client.get(`api/residential-projects/${rpId}/summary-report-generation`)
  }
}
